import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface Authtate {
  userData: any;
}

const initialState: Authtate = {
  userData: {},
};

export const Authlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveUserData: (state, action: PayloadAction<any>) => {
      state.userData = action.payload;
    },
  },
});

export const { saveUserData } = Authlice.actions;

export default Authlice.reducer;
